import { BulkUpdateProgressBanner } from "#src/batteries-included-components/Banners/BulkUpdateProgressBanner/BulkUpdateProgressBanner";
import { ESTIMATION_METHODS_QUERY_KEY } from "#src/components/hooks/adapters/useEstimationMethods";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { useQueryClient } from "@tanstack/react-query";
import { AssetStatus } from "@validereinc/domain";
import React from "react";
import { useParams } from "react-router";

export const FacilityUpdateStatusBanner = () => {
  const { facilityId } = useParams<{ facilityId: string }>();
  const queryClient = useQueryClient();
  const [updateFacilityStatusJobStorageKey] = useStorageKey(
    ["async-job"],
    `update-facility-status-${facilityId}`
  );
  return (
    <BulkUpdateProgressBanner
      jobStorageKey={updateFacilityStatusJobStorageKey}
      invalidate={() => {
        queryClient.refetchQueries({
          predicate: (query) =>
            [
              "facilities",
              "equipment",
              "flows",
              "devices",
              ESTIMATION_METHODS_QUERY_KEY,
            ].some((key) => query.queryKey.includes(key)),
          type: "all",
        });
      }}
      subject={{
        singular: "asset",
        plural: "assets",
      }}
      action={(job) =>
        job?.input.status === AssetStatus.INACTIVE ? "inactivate" : "activate"
      }
    />
  );
};
